'use strict';

angular.module('userRequestEditControllers')

.controller('SelectSystemRolesModalController', ['$scope', 'businessSystemService', 'editAccessRequestService', function ($scope, businessSystemService, editAccessRequestService) {

    $scope.ctxtSelect = {};

    var editService = editAccessRequestService.systemRolePendings;
   
    var pendingsByID = _.indexBy($scope.userRequest.SystemRolePendings, 'SystemRoleID');
    var existingsByID = _.indexBy($scope.userRequest.existings, 'SystemRoleID');

    // Retrieve all system roles for this system in backend
    var mapPendingsAndExistings =  function (systemRoles) {
        $scope.systemRoles = _.map(systemRoles, function (systemRole) {
            var pending = pendingsByID[systemRole.SystemRoleID];
            if (pending) { 
                systemRole.ToAdd = pending.ToAdd;
                systemRole.ToRemove = pending.ToRemove;
                systemRole.ToKeep = pending.ToKeep;

                systemRole.StatusPending = 'NotImpacted';
                if (systemRole.ToKeep === true) {
                    systemRole.StatusPending = 'Keep';
                }
                else if (systemRole.ToAdd === true) {
                    systemRole.StatusPending = 'PreAdd';
                }
                else if (systemRole.ToAdd === false) {
                    systemRole.StatusPending = 'PreClose';
                }
            }

            var existing = existingsByID[systemRole.SystemRoleID];
            if (existing) { systemRole.IsExisting = true; }

            return systemRole;
        });
    }

    // Local roles or All roles in business system
    if ($scope.getAllRoles === true || $scope.getAllRoles === 'true') {
        businessSystemService.getActiveSystemRolesByBusinessSystem($scope.system.SystemID)
        .then(mapPendingsAndExistings);
    } else {
        mapPendingsAndExistings($scope.systemRoles);
    }

    // Actions Pre ADD
    $scope.preAdd = function (systemRole) {
        editService.preAdd($scope.userRequest.UserAccessRequestID, systemRole.SystemRoleID)
        .then(function (updatedSystemRole) {
            if (!_.isUndefined(updatedSystemRole.GrowlMessages)) return;

            systemRole.ToKeep = undefined;
            systemRole.ToAdd = true;
            systemRole.StatusPending = 'PreAdd';
        });
    }

    // Actions Pre CLOSE
    $scope.preClose = function (systemRole) {
        editService.preClose($scope.userRequest.UserAccessRequestID, systemRole.SystemRoleID)
        .then(function (updatedSystemRole) {
            if (!_.isUndefined(updatedSystemRole.GrowlMessages)) return;

            systemRole.ToKeep = undefined;
            systemRole.ToAdd = false;
            systemRole.StatusPending = 'PreClose';
        });
    }

    // Actions DELETE
    $scope.delete = function (systemRole) {
        editService.delete($scope.userRequest.UserAccessRequestID, systemRole.SystemRoleID)
        .then(function (updatedSystemRole) {
            if (!_.isUndefined(updatedSystemRole.GrowlMessages)) return;

            systemRole.ToKeep = undefined;
            systemRole.ToAdd = undefined;
            systemRole.StatusPending = 'NotImpacted';
        });
    }

    // Actions KEEP
    $scope.keep = function (systemRole) {
        editService.keep($scope.userRequest.UserAccessRequestID, systemRole.SystemRoleID)
        .then(function (updatedSystemRole) {
            if (!_.isUndefined(updatedSystemRole.GrowlMessages)) return;

            systemRole.ToKeep = true;
            systemRole.StatusPending = 'Keep';
        });
    }

    // Actions REVERT KEEP
    $scope.revertKeep = function (systemRole) {
        editService.revertKeep($scope.userRequest.UserAccessRequestID, systemRole.SystemRoleID)
        .then(function (updatedSystemRole) {
            if (!_.isUndefined(updatedSystemRole.GrowlMessages)) return;

            systemRole.ToKeep = undefined;
            systemRole.StatusPending = 'PreClose';
        });
    }
}]);